import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, Settings } from 'lucide-react';
const backpackLogo = process.env.PUBLIC_URL + '/assets/logo.jpg';

const HomeHeader = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    const handleLogout = () => {
        // Clear user session or token storage
        localStorage.removeItem('authData');
        localStorage.removeItem('userData');

        // Redirect to login page
        navigate('/login');
    };
    return (
        <header style={headerStyle}>
            <div style={leftSectionStyle}>
                <Menu size={35} color="#fff" style={iconStyle} onClick={toggleMenu} />
                <img src={backpackLogo} alt="BackpackEMR Logo" style={logoStyle} />
                <Link to="/organizations" style={titleLinkStyle}>
                    <span style={titleStyle}>Web Admin</span>
                </Link>


            </div>
            {menuOpen && (
                <div style={hamburgerMenuStyle}>
                    <a href="https://myBackpackEMR.com" style={hamburgerItemStyle}>Web Portal</a>
                    <a href="https://salesreach-free.salesreach.io/backpackemr-training-manuals-and-tutorials" style={hamburgerItemStyle}>Support and Tutorials</a>
                    <span onClick={handleLogout} style={hamburgerItemStyle}>Logout</span>
                </div>
            )}
        </header>
    );
};

const headerStyle = {
    backgroundColor: '#006d7d',
    color: '#fff',
    padding: '10px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
};

const leftSectionStyle = {
    display: 'flex',
    alignItems: 'center',
};

const logoStyle = {
    width: '50px',
    height: '50px',
    marginLeft: '15px',
    marginRight: '10px',
};

const titleStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
};

const navAndSettingsWrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
};

const rightSectionStyle = {
    display: 'flex',
    alignItems: 'center',
};

const iconStyle = {
    cursor: 'pointer',
};

const titleLinkStyle = {
    textDecoration: 'none',
    color: '#fff',
};

const hamburgerMenuStyle = {
    position: 'absolute',
    top: '60px',
    left: '10px',
    backgroundColor: '#006d7d',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '5px',
    zIndex: 1000,
    width: '200px',
    flexDirection: 'column',
};

const hamburgerItemStyle = {
    padding: '10px 20px',
    color: '#fff',
    textDecoration: 'none',
    display: 'block',
    fontSize: '16px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
    cursor: 'pointer',
};
const logoutStyle = {
    color: '#fff',
    textDecoration: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    marginLeft: '30px',
};


export default HomeHeader;
